import React, { useEffect } from "react";
import { useVeltClient } from "../context";
export function useAutocompleteUtils() {
    var _a = React.useState(), autocompleteElement = _a[0], setAutocompleteElement = _a[1];
    var client = useVeltClient().client;
    React.useEffect(function () {
        if (!client || autocompleteElement)
            return;
        var loadedAutocompleteElement = client.getAutocompleteElement();
        setAutocompleteElement(loadedAutocompleteElement);
    }, [client, setAutocompleteElement, autocompleteElement]);
    return autocompleteElement;
}
export function useAutocompleteChipClick() {
    var autocompleteElement = useAutocompleteUtils();
    var _a = React.useState(), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!autocompleteElement)
            return;
        var subscription = autocompleteElement.onAutocompleteChipClick().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [autocompleteElement]);
    return data;
}
